<template>
<div>
  <e-chart ref="chart" />
</div>
</template>

<script>
import calc from '../Data/calc'
import EChart from '../Charts/ECharts'

export default {
  name: 'RelatedMatrixChart',
  components: {EChart},
  props: {
    query: {
      required: true,
      type: Object
    },
    factorMap: {
      required: true,
      type: Object
    },
    dataList: {
      required: true,
      type: Array
    }
  },
  computed: {
    seriesDataList () {
      const {dataList, query, factorMap} = this
      const {factorIds} = query
      const dataMap = dataList.reduce((map, data) => {
        const {factorId} = data
        const factor = factorMap[factorId]

        if (factor) {
          const factorDataMap = map[factorId]

          if (factorDataMap) {
            const {flag} = data
            factorDataMap[data.dataTime] = {
              value: data.value,
              isExcept: flag !== 'N' || flag === null
            }
          }
        }

        return map
      }, factorIds.reduce((map, factorId) => {
        map[factorId] = {}
        return map
      }, {}))

      const seriesDataList = []
      const factorIdsLen = factorIds.length

      for (let i = 0; i < factorIdsLen; i++) {
        const xFactorId = factorIds[i]
        const xFactorData = Object.entries(dataMap[xFactorId])

        for (let j = i; j < factorIdsLen; j++) {
          const yFactorId = factorIds[j]
          const yFactorData = dataMap[yFactorId]
          const xDataList = []
          const yDataList = []

          xFactorData.forEach(([dataTime, data]) => {
            const yData = yFactorData[dataTime]

            if (yData) {
              xDataList.push(data)
              yDataList.push(yData)
            }
          })

          let {r} = calc.calcRelated(xDataList, yDataList)

          if (Number.isFinite(r)) {
            r = Math.round(r * 100)
            seriesDataList.push([i, j, r], [j, i, r])
          }
        }
      }

      return seriesDataList
    }
  },
  methods: {
    renderChart () {
      console.time('RelatedMatrixChart')

      if (!this.query.factorIds) {
        return
      }

      const {query: {factorIds}, factorMap} = this
      const factorNames = factorIds.map(factorId => factorMap[factorId].name)
      const chartOpt = {
        tooltip: {
          formatter: param => {
            const {value} = param
            const {query: {factorIds}, factorMap} = this
            return `<div style="display:grid;grid-template-columns:repeat(2,max-content);grid-column-gap:5px;grid-row-gap:5px;"><label>x:</label><span style="text-align:right">${factorMap[factorIds[value[0]]].name}</span><label>y:</label><span style="text-align:right">${factorMap[factorIds[value[1]]].name}</span><label>r:</label><span style="text-align:right">${value[2]}</span></div>`
          },
          appendToBody: true,
          trigger: 'item',
          axisPointer: {
            type: 'cross'
          }
        },
        grid: {
          top: 0,
          right: 80,
          bottom: 0,
          left: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: factorNames,
          axisLabel: {
            rotate: 90
          }
        },
        yAxis: {
          type: 'category',
          data: factorNames
        },
        visualMap: {
          min: -100,
          max: 100,
          dimension: 2,
          orient: 'vertical',
          right: 10,
          top: 'center',
          // text: ['HIGH', 'LOW'],
          calculable: true,
          inRange: {
            // color: ['#f2c31a', '#24b7f2']
            color: ['rgb(0,228,0)', 'rgb(255,255,0)', 'rgb(255,126,0)', 'rgb(255,0,0)', 'rgb(153,0,76)', 'rgb(126,0,35)']
          }
        },
        series: [{
          name: '相关性矩阵图',
          type: 'scatter',
          data: this.seriesDataList,
          label: {
            show: true,
            formatter: param => param.value[2],
            color: '#303133',
            textBorderWidth: 1,
            textBorderColor: '#fff'
          },
          symbolSize: value => [Math.max(3, 20 - (Math.abs(value[2]) / 5)), 20],
          symbolRotate: value => value[2] < 0 ? 45 : -45
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
      console.timeEnd('RelatedMatrixChart')
      let that = this
      this.$refs.chart.myChart.on('click', (params) => {
        const {value} = params
        const {query: {factorIds}, factorMap} = that
        let ids = []

        if (factorMap[factorIds[value[0]]].id && factorMap[factorIds[value[1]]].id) {
          ids.push(factorMap[factorIds[value[0]]].id)
          ids.push(factorMap[factorIds[value[1]]].id)
        }

        that.$eventBus.emit('onCorrelationClick', {factorIds: ids})
      })
    }
  },
  watch: {
    dataList () {
      this.renderChart()
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/RelatedMatrixChart/index.vue